<template>
<div class="container mt-5">
    <div class="col-md-6 mx-auto">
        <h1 class="text-center">404</h1>
        <h1>
            This is not the webpage you are looking for!
        </h1>
    </div>
</div>
</template>

<script>

export default {
 
   data () {
    return {
    }
  }, 

}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/additions/PageNotFound.vue